import * as React from "react";
const SvgRepeat = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.667 5.8335H13.333C16.0944 5.8335 18.333 8.07207 18.333 10.8335C18.333 13.5949 16.0944 15.8335 13.333 15.8335H6.66699C3.90557 15.8335 1.66699 13.5949 1.66699 10.8335C1.66699 8.07207 3.90557 5.8335 6.66699 5.8335M5.83366 3.3335L8.33366 5.8335L5.83366 8.3335",
      stroke: "#006CFD",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgRepeat;
